var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import { Col, Row } from 'react-bootstrap';
import FieldBuilder from './FieldBuilder';
import PropTypes from 'prop-types';
import React from 'react';

function RowBuilder(_ref) {
  var colSize = _ref.colSize,
      row = _ref.row;

  return React.createElement(
    Row,
    null,
    row.map(function (field, i) {
      var _ref2;

      return React.createElement(
        Col,
        _extends({
          key: i
        }, (_ref2 = {}, _ref2[colSize] = field.width || 12 / row.length, _ref2[colSize + 'Offset'] = field.offset || 0, _ref2)),
        React.createElement(FieldBuilder, { field: field })
      );
    })
  );
}

RowBuilder.propTypes = process.env.NODE_ENV !== "production" ? {
  colSize: PropTypes.string.isRequired,
  row: PropTypes.array.isRequired
} : {};

export default RowBuilder;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bodyspec-form-builder/es/RowBuilder.js
// module id = 669
// module chunks = 0